import axios from "axios";
import get from "lodash/fp/get";
import mapValues from "lodash/fp/mapValues";

export default function fetchRecipe({ signal }) {
  const source = axios.CancelToken.source();

  if (signal) {
    signal.addEventListener("abort", () => {
      source.cancel();
    });
  }

  return ({ recipeID }) =>
    axios({
      url: `${process.env.REACT_APP_CREATE_RECIPE_URL}`,
      method: "GET",
      cancelToken: source.token,
      params: {
        recipeID: recipeID.toLowerCase(),
      },
    })
      .then(get(["data", "Items", 0]))
      .then((item) => {
        if (!item) {
          throw new Error("invalid recipe ID");
        }
        return item;
      })
      .then(mapValues(get(["S"])));
}
